<template>
    <div>
        <base-crud crudName="Relatório de Eventos - Geral" newText="Novo Turno" :table="eventTable" :columns="columns"
            :options="options" :endPoint='endPoint' :enableExtract="true" :enableAdd="false" :enableEdit="false"
            :enableDelete="true" :enableView="true" :enablePdf="false" with="">
        </base-crud>
    </div>
</template>

<script>
import BaseCrud from '../Base/BaseCrud'

export default {
    data: function () {
        return {
            eventTable: 'eventTable',
            events: [],
            pages: [],
            url: '',
            columns: ['id', 'theme_id', 'shift_id', 'branch_id', 'team_id', 'status_id', 'created_at', 'dds_date', 'actions'],
            tableData: ['id', 'theme_id', 'shift_id', 'branch_id', 'team_id', 'status_id', 'created_at', 'dds_date'],
            options: {
                dateFormat: 'DD/MM/YYYY',
                // dateColumns: ['created_at','dds_date'],
                datepickerOptions: {
                    customClass: 'form-control',
                    startDate: moment().startOf('hour'),
                    endDate: moment().startOf('hour').add(32, 'hour'),
                    "locale": {
                        "format": "DD/MM/YYYY",
                        "separator": " - ",
                        "applyLabel": "Aplicar",
                        "cancelLabel": "Cancelar",
                        "fromLabel": "De",
                        "toLabel": "Até",
                        "customRangeLabel": "Selecionar",
                        "weekLabel": "S",
                        "daysOfWeek": [
                            "Dom",
                            "Seg",
                            "Ter",
                            "Qua",
                            "Qui",
                            "Sex",
                            "Sab"
                        ],
                        "monthNames": [
                            "Janeiro",
                            "Fevereiro",
                            "Março",
                            "Abril",
                            "Maio",
                            "Junho",
                            "Julho",
                            "Agosto",
                            "Setembro",
                            "Outubro",
                            "Novembro",
                            "Dezembro"
                        ],
                        "firstDay": 1
                    }
                },
                filterable: [
                    "id",
                    "theme_id",
                    // "shift_id",
                    "status_id",
                    "team_id",
                    "branch_id",
                    'created_at',
                    "dds_date"
                ],
                filterByColumn: true,
                debounce: 1000,
                sortable: ['id', 'theme_id', 'branch_id', 'team_id', 'teams_shifts.shift.id', 'status_id', 'created_at', 'dds_date'],
                pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    'id': 'ID Evento',
                    'theme_id': 'Tema',
                    'shift_id': 'Turno',
                    'branch_id': 'Unidade',
                    'team_id': 'Área',
                    'status_id': 'Status',
                    'created_at': 'Data de Criação',
                    'dds_date': 'Data de Execução',
                    'actions': 'Ações'
                },
                templates: {
                    theme_id: function (h, row, index) {
                        return row.simplified_theme ? row.simplified_theme.title : '';
                    },
                    shift_id: function (h, row, index) {
                        return row.teams_shifts ? row.teams_shifts.shift.name : '';
                    },
                    branch_id: function (h, row, index) {
                        return row.branch ? row.branch.name : '-';
                    },
                    team_id: function (h, row, index) {
                        return row.teams_shifts ? row.teams_shifts.team.name : '';
                    },
                    status_id: function (h, row, index) {
                        return row.status ? row.status.name : '';
                    },
                    created_at: function (h, row, index) {
                        return new Date(row.created_at).toLocaleDateString();
                    },
                    dds_date: function (h, row, index) {
                        return new Date(row.dds_date).toLocaleDateString();
                    }
                },
                requestFunction: function (data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = [
                      
                        'status',
                        'teams_shifts',
                        'teams_shifts.team',
                        'teams_shifts.shift',
                        'created_at',
                        'dds_date',
                        'branch'
                    ];

                    query += "&orderByDesc=id";

                    return axios.get(this.url + "?" + query, requestData).catch(
                        function (e) {
                            this.dispatch("error", e);
                        }.bind(this)
                    );
                }
            },
            endPoint: 'events/'
        }
    },
    methods: {
        converteData(dataNoFormatoOriginal){
            var componentes = dataNoFormatoOriginal.split('/');

            // Obter os valores do dia, mês e ano
            var dia = componentes[0];
            var mes = componentes[1];
            var ano = componentes[2];

            // Formatando a data para "aaaa-mm-dd"
            var dataFormatada = ano + '-' + mes + '-' + dia;

            return dataFormatada;
        },
        query: function (query) {

            let self = this
            let columns = {
                id: 'id',
                theme_id: 'theme[title]',
                shift_id: 'teams_shifts.shift[name]',
                branch_id: 'branch[name]',
                team_id: 'teams_shifts.team[name]',
                status_id: 'status[name]',
                created_at: 'created_at',
                dds_date: 'dds_date'
            };
            let filters = '';
            $.each(query, function (index, value) {
                // if (index == 'dds_date') {
                //   filters += `${columns[index]}=${moment(value.start).format("YYYY-MM-DD")},${moment(value.end).format("YYYY-MM-DD")}`;
                debugger
                if (index == 'created_at') {
                    filters += `${columns[index]}=${self.converteData(value)},${self.converteData(value)}` + '&';                    
                } else if (index == 'dds_date') {
                    filters += `${columns[index]}=${self.converteData(value)},${self.converteData(value)}` + '&'
                } else if (index == 'theme_id') {
                    filters += 'theme[title]=' + value + '&'
                } else if (index == 'team_id') {
                    filters += 'teams_shifts.team[name]=' + value + '&'
                } else if (index == 'branch_id') {
                    filters += 'branch[name]=' + value + '&'
                } else {
                    filters += columns[index] + '=' + value + '&';
                }
            });
            return filters;
        }
    },
    components: {
        BaseCrud
    }
}
</script>

<style scoped>
.VuePagination {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Event/Crud.vue